import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch } from "../app/store";
import { userLoggedOut } from "../features/auth/authSlice";
import useAuth from "../hooks/useAuth";
import { Role } from "../types";

interface PrivateRouteProps {
  children: ReactNode;
  roles: Role[];
}

export default function PrivateRoute({ children, roles }: PrivateRouteProps) {
  // TODO: open when work with api
  const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();
  const isAuth = useAuth(roles);

  useEffect(() => {
    if (!isAuth) {
      keycloak.logout({
        redirectUri: window.location.origin + "/",
      });
      dispatch(userLoggedOut());
    }
  }, [dispatch, isAuth, keycloak]);

  if (isAuth) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/sign-in" />;

  // return <Fragment>{children}</Fragment>;
}
